/** @jsx jsx */
import { jsx, Container, Text } from 'theme-ui'

export default () => (
  <Container sx={{color: 'muted', pb: 5}} as="footer">
    <Text>© {new Date().getFullYear()} Maxim Melnikov.</Text>
  </Container>
)
